<template>
  <div class="clientFundDetailExchange">
    <van-form
      label-width="120px"
      :show-error="false"
      :scroll-to-error="false"
      @submit="onSubmit"
    >
      <van-field
        v-model="form.ExchangeSCIdSn"
        :label="$t.clientFund.fromCurrecny"
        @click="pickerShow('showCurrencyPicker', 1)"
        :placeholder="$t.meta.select"
        clickable
        readonly
        required
        :rules="formRule"
      />

      <van-field
        v-model="form.ExchangeAmount"
        :label="$t.clientFund.exchangeAmount"
        @change="getBalance"
        :placeholder="$t.meta.input"
        oninput="if(value === ''){value = null} if (isNaN(value)) {value = null}"
        required
        :rules="formRule"
      />

      <div class="custom-field">
        <div class="custom-field-label">{{ $t.clientFund.beforeBlance }}</div>
        <div class="custom-field-value">
          <span v-if="form.ExchangeAmount > 0">{{
            numFormat(form.BeforeBlance - form.ExchangeAmount)
          }}</span>
          <span v-else>{{ numFormat(form.BeforeBlance) }}</span>
        </div>
      </div>

      <div class="custom-field-symbol">
        <van-image
          width="20"
          height="20"
          :src="require('@/assets/img/financialManagement/multiply.png')"
        ></van-image>
      </div>

      <van-field
        v-model="form.ExchangeRate"
        :label="$t.clientFund.rate + '( % )'"
        @change="getBalance"
        :placeholder="$t.meta.input"
        oninput="if(value === ''){value = null} if (isNaN(value)) {value = null}"
        required
        :rules="formRule"
      />

      <div class="custom-field-symbol">
        <van-image
          width="20"
          height="20"
          :src="require('@/assets/img/financialManagement/equal.png')"
        ></van-image>
      </div>

      <van-field
        v-model="form.ConvertSCIdSn"
        :label="$t.clientFund.toCurrency"
        @click="pickerShow('showCurrencyPicker', 2)"
        :placeholder="$t.meta.select"
        clickable
        readonly
        required
        :rules="formRule"
      />

      <div class="custom-field">
        <div class="custom-field-label">{{ $t.clientFund.toAmount }}</div>
        <div class="custom-field-value">
          <span>{{ form.ConvertAmount }}</span>
        </div>
      </div>

      <div class="custom-field">
        <div class="custom-field-label">{{ $t.clientFund.afterBlance }}</div>
        <div class="custom-field-value">
          <span>{{ numFormat(form.AfterBlance) }}</span>
        </div>
      </div>

      <div style="margin: 16px">
        <van-button round block type="info" native-type="submit">{{
          $t.meta.submit
        }}</van-button>
      </div>
    </van-form>

    <van-popup v-model="showCurrencyPicker" round position="bottom">
      <van-picker
        :title="$t.meta.currency"
        show-toolbar
        :columns="currencyList"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="currencyConfirm($event)"
        @cancel="showCurrencyPicker = false"
      />
    </van-popup>
  </div>
</template>
<script>
import Vue from "vue";
import { Form, Field, Image, Button, Popup, Picker } from "vant";

Vue.use(Form).use(Field).use(Image).use(Button).use(Popup).use(Picker);

export default {
  name: "clientFundDetailExchange",
  data() {
    return {
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      form: {
        CustomerId: null,
        ExchangeSCIdSn: "",
        ExchangeSCId: null,
        ExchangeRate: null,
        ConvertSCIdSn: "",
        ConvertSCId: null,
        ExchangeAmount: null,
        ConvertAmount: 0.0,
        BeforeBlance: 0.0,
        AfterBlance: 0.0,
      },
      formRule: [
        {
          required: true,
          message: this.$t.meta.require,
        },
      ],
      //选项
      currencyList: [],
      showCurrencyPicker: false,
    };
  },
  created() {
    const { CustomerId } = this.$route.query;
    if (CustomerId) {
      this.form.CustomerId = CustomerId;
      this.getCurrencyList();
    }
  },
  methods: {
    rateChange() {
      this.form.ConvertAmount = this.form.ExchangeRate * this.form.ExchangeAmount;

      if (this.form.ConvertAmount > 0) {
        if (this.form.ConvertSCId) {
          this.form.AfterBlance = this.form.AfterBlance + this.form.ConvertAmount;
        }
      } else {
        this.form.AfterBlance = 0.0;
      }

      this.form.ConvertAmount = this.form.ConvertAmount.toFixed(2);
    },
    getBalance() {
      for (var cy of this.currencyList) {
        if (cy.value == this.form.ExchangeSCId) {
          this.form.BeforeBlance = cy.AmountBalance;
        }
        if (cy.value == this.form.ConvertSCId) {
          this.form.AfterBlance = cy.AmountBalance;
        }
      }
      if (this.form.ExchangeRate && this.form.ExchangeAmount) this.rateChange();
    },
    getCurrencyList() {
      return new Promise((resolve) => {
        var param = {
          CustomerId: this.form.CustomerId,
        };
        this.$api.financialManagement
          .getCustomerAvailableFundListByCustomerId(param)
          .then((res) => {
            var result = [];
            res.data.forEach((item) => {
              let data = {
                text: item.CurrencySn + " ( " + item.AmountBalance + " ) ",
                value: item.SCId,
                AmountBalance: item.AmountBalance,
              };
              result.push(data);
            });
            this.currencyList = result;
            this.getBalance();
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    pickerShow(pickerName, type) {
      this[pickerName] = true;
      this.itemType = type;
    },
    currencyConfirm(e) {
      if (this.itemType == 1) {
        if (e.value == this.form.ConvertSCId) {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.clientFund.currencyError,
            type: "error",
          });
          return;
        }
        this.form.ExchangeSCIdSn = e.text;
        this.form.ExchangeSCId = e.value;
        this.showCurrencyPicker = false;
        this.getBalance();
      }
      if (this.itemType == 2) {
        if (e.value == this.form.ExchangeSCId) {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.clientFund.currencyError,
            type: "error",
          });
          return;
        }
        this.form.ConvertSCIdSn = e.text;
        this.form.ConvertSCId = e.value;
        this.showCurrencyPicker = false;
        this.getBalance();
      }
    },
    onSubmit() {
      var param = {};
      param = this.form;
      this.$commonMethod.showLoading();
      this.$api.financialManagement
        .addCustomerFundExchangeRecord(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.$commonEnv.commonAction(this.$commonEnv.actionType.pop);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    numFormat(num) {
      num = num.toFixed(2);
      var result = num.toString().replace(/\d+/, function (n) {
        return n.replace(/(\d)(?=(\d{3})+$)/g, function ($1) {
          return $1 + ",";
        });
      });
      return result;
    },
  },
};
</script>
<style lang="scss" scoped>
.clientFundDetailExchange {
  ::v-deep .number-label {
    line-height: 33px;
  }
  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }
  .van-cell::after {
    border: none !important;
  }
  ::v-deep .van-radio__icon--disabled.van-radio__icon--checked {
    i {
      color: #1890ff;
      font-weight: bold;
    }
  }
  ::v-deep .van-radio__label--disabled.van-radio__label {
    color: #646566 !important;
    -webkit-text-fill-color: #646566 !important;
  }
  ::v-deep .van-checkbox__icon--disabled.van-checkbox__icon--checked {
    i {
      color: #1890ff;
      font-weight: bold;
    }
  }
  ::v-deep .van-checkbox__label--disabled.van-checkbox__label {
    color: #646566 !important;
    -webkit-text-fill-color: #646566 !important;
  }
  ::v-deep .van-field--disabled {
    .van-field__label,
    .van-field__control {
      color: #646566 !important;
      -webkit-text-fill-color: #646566 !important;
    }
  }
  .custom-field {
    font-size: 14px;
    padding: 12px 16px;
    border-bottom: 1px solid #ebedf0;
    .custom-field-label {
      width: 120px;
      display: inline-block;
      margin-right: 12px;
      font-size: 14px;
      color: #999;
    }
    .custom-field-value {
      width: 50%;
      display: inline-block;
      font-size: 14px;
      color: #323233;
    }
  }
  .custom-field-symbol {
    text-align: center;
    padding: 10px;
    border-bottom: 1px solid #ebedf0;
    background: #f1f1f1;
    .van-image {
      vertical-align: bottom;
    }
  }
}
</style>
